import { bl_fi_deposit_txn_category_hdr_RowClass } from '../../dbschema/bl_fi_deposit_txn_category_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositTxnCategoryContainerModel extends BaseContainerModel {
  bl_fi_deposit_txn_category_hdr: bl_fi_deposit_txn_category_hdr_RowClass = new bl_fi_deposit_txn_category_hdr_RowClass();
}
